module.exports = __webpack_public_path__ + "assets/img/icon-toutiao-mnp.b807ff3a.png";